module.exports = __webpack_public_path__ + "img/logo.37121495.png";